export default "__VITE_ASSET__S2bIkRLe__"